import { axios } from '@/utils/request'

export const homeList = () => {
  return axios.get('/api/web/biz/home/list')
}
export const order = (data) => {
  return axios.post('/api/web/biz/order', data)
}
